var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3138",
    "data-name": "Group 3138",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.7,
    height: 16,
    viewBox: "0 0 17.7 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3137",
    "data-name": "Group 3137",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8485",
    "data-name": "Path 8485",
    d: "M10.329,1H5.286a1.816,1.816,0,0,0-1.56.886L1.256,6.027a1.818,1.818,0,0,0,0,1.86l2.47,4.141a1.816,1.816,0,0,0,1.56.886h5.043a1.815,1.815,0,0,0,1.56-.886l2.47-4.141a1.814,1.814,0,0,0,0-1.86l-2.47-4.141A1.815,1.815,0,0,0,10.329,1Z",
    transform: "translate(1.043 1.043)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8486",
    "data-name": "Path 8486",
    d: "M10.969,7.583a2.463,2.463,0,0,1-4.923,0,2.463,2.463,0,0,1,4.923,0Z",
    transform: "translate(0.291 0.417)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.5c91e988541b93ec6794b1d57e1a8b71.svg";
export { ForwardRef as ReactComponent };